import { useEffect } from 'react';
import { getPollsByIdCard } from '../api/pollsInPluginData';
declare global {
  interface Window {
    TrelloPowerUp: any;
    ga: any;
    Trello: any;
    LZUTF8: any;
  }
}

const initialize = () => {
  window.TrelloPowerUp.initialize(
    {
      'card-buttons': (t: any) => {
        return [
          {
            text: 'Add a poll',
            condition: 'edit',
            icon: './polls-icon.png', // Must be a gray icon, colored icons not allowed.
            callback: (x: any) => {
              x.popup({
                title: 'Add a Poll',
                url: './createPoll',
                height: 260,
              });
            },
          },
        ];
      },

      'card-back-section': async (t: any) => {
        const polls = await getPollsByIdCard(t);

        if (polls && polls.length) {
          return {
            title: 'Polls',
            icon: './polls-icon.png', // Must be a gray icon, colored icons not allowed.
            content: {
              type: 'iframe',
              url: t.signUrl('./cardBackSection'),
              height: 230, // Max height is 1500.
            },
            action: {
              text: 'Manage',
              callback: (x: any) => {
                x.popup({
                  title: 'Polls - Manage',
                  items: [
                    {
                      text: 'Add a new poll',
                      callback: (y: any) => {
                        y.popup({
                          title: 'Add a Poll',
                          url: './createPoll',
                          height: 280,
                        });
                      },
                    },
                    {
                      text: 'Delete a poll',
                      callback: (y: any) => {
                        y.popup({
                          title: 'Delete a poll',
                          items: polls.map((poll: any, index: number) => ({
                            text: poll.name,
                            callback: async (z: any) => {
                              const confirmed = window.confirm(
                                'Are you sure you want to delete this poll? There is no undo.'
                              );
                              if (confirmed) {
                                const newPolls = polls;
                                newPolls.splice(index, 1);

                                await t.set(
                                  'card',
                                  'shared',
                                  'polls',
                                  newPolls
                                );

                                z.closePopup();
                              }
                            },
                          })),
                        });
                      },
                    },
                  ],
                });
              },
            },
          };
        }
      },

      'show-settings': async (t: any) => {
        const isAuthorized: boolean = await t.getRestApi().isAuthorized();

        if (!isAuthorized) {
          t.popup({
            title: 'Polls - Settings',
            items: [
              {
                text: 'Authorize',
                callback: (x: any) => {
                  x.popup({
                    title: 'Authorize Polls',
                    url: './authorize',
                    height: 260,
                  });
                },
              },
            ],
          });

          return;
        }

        t.popup({
          title: 'Polls - Settings',
          items: [
            {
              text: 'Manage subscription...',
              callback: async (x: any) => {
                return x.modal({
                  title: 'Polls - Subscription',
                  url: './payment',
                  fullscreen: true,
                });
              },
            },
          ],
        });
      },
    },
    {
      appKey: '8601ea45bb03e7e90ede1521a391a158',
      appName: 'Polls',
    }
  );
};

export const IframeConnector = () => {
  useEffect(() => {
    initialize();
  }, []);

  return <div>ok</div>;
};
